// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/index.js!./waves.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("8a28ac16", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/directives/package/assets/waves.css
// module id = 272
// module chunks = 0